export const VEHICLE_TYPES = {
  CARS: 'cars',
  VANS: 'vans',
  OLDTIMERS: 'oldtimers',
  TRUCKS: 'trucks',
};

export const VEHICLE_TYPE_CATEGORY_IDS = {
  CARS: '91',
  VANS: '95',
  TRUCKS: '159',
  OLDTIMERS: '137',
};

export const VEHICLE_TYPE_CATEGORY_IDS_NUM = {
  vans: 95,
  oldtimers: 137,
  trucks: 159,
};

export const VEHICLE_TYPE_EV = 'evs';
